import _ from 'underscore';

export function generateCustomReportBuilderMenuItem({
  siteMap, i18n, navigate, onClickCustomReportBuilderItem
}) {
  const siteMapItem = _.find(siteMap[0].children, { id: 'reports-v4-build-custom-report' });

  const rootMenuItem = {
    key: 'custom-report-builder-title',
    text: i18n.getString(_TL_('Build your own report')),
    onClick: (event, menuItem) => {
      navigate(siteMapItem.route);
      onClickCustomReportBuilderItem({ menuItem });
    },
  };

  return rootMenuItem;
}
